import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import KeyContactsTable from '../../components/KeyContactsTable';
import {
  fetchKeyContacts,
  clearKeyContacts,
} from 'src/store/actions/keyContacts';
import { setSearch } from 'src/store/actions/search';
import { selectCurrentUserSuite } from 'src/store/selectors/userSuites';
import { selectKeyContacts } from 'src/store/selectors/KeyContacts';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const KeyContacts = () => {
  const dispatch = useDispatch();

  const keyContacts = useSelector(selectKeyContacts);
  const currentUserSuite = useSelector(selectCurrentUserSuite);
  const loader = useSelector(selectPRLoader);

  useEffect(() => {
    dispatch(clearKeyContacts());
    if (currentUserSuite && currentUserSuite.propertyId) {
      dispatch(fetchKeyContacts(currentUserSuite.propertyId));
    }
  }, []);

  const keyContactsTabItems = useMemo(() => [
    {
      label: 'Key Contacts',
      content: (
        <KeyContactsTable
          keyContacts={keyContacts}
          onSearch={(e) =>
            dispatch(setSearch({ keyContacts: e.target.value.trim() }))
          }
        />
      ),
    },
  ], [keyContacts, dispatch]);

  return (
    <>
      {loader ? <Loader center={true} /> : null}
      <WithNavigation
        title="Key Contacts"
        top={
          <Heading
            headline="Key Contacts"
            items={[
              {
                key: 'Key Contacts',
                value: keyContacts.length,
              },
            ]}
          />
        }
        bottom={
          <Tabs
            items={keyContactsTabItems}
          />
        }
      />
    </>
  );
};

export default KeyContacts;